import type { CreateTimestampUid } from './types';

export const createTimestampUid: CreateTimestampUid = () => (
  (Date.now() * Math.random()).toString(36)
);
